module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-boost-32-active.37ba1ced.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-boost-32-active.png
// module id = 3188
// module chunks = 11